// Reviews: pagination, tab switching, dynamic dates, JS-rendered store reviews.
(() => {
  function relAge(offsetH) {
    if (offsetH < 1) return 'most';
    if (offsetH < 2) return '1 órája';
    if (offsetH < 24) return Math.round(offsetH) + ' órája';
    var d = Math.round(offsetH / 24);
    if (d === 1) return 'tegnap';
    if (d < 7) return d + ' napja';
    var w = Math.round(d / 7);
    if (w === 1) return '1 hete';
    if (w < 5) return w + ' hete';
    var m = Math.round(d / 30);
    if (m <= 1) return '1 hónapja';
    return m + ' hónapja';
  }

  function stars(n) {
    var full = '';
    for (var j = 0; j < n; j++) full += '★';
    if (n < 5) {
      full += '<span>';
      for (var j = 0; j < 5 - n; j++) full += '★';
      full += '</span>';
    }
    return full;
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  var init = function(root) {
    var pageSize = Number(root.dataset.reviewsPages) || 1;
    var storeTotal = Number(root.dataset.reviewsStoreTotal) || 0;
    var storePerPage = Number(root.dataset.reviewsStorePerPage) || 8;
    var storePageCount = storeTotal > 0 ? Math.ceil(storeTotal / storePerPage) : 0;

    var reviews = [].slice.call(root.querySelectorAll('[data-reviews-page]'));
    var buttons = [].slice.call(root.querySelectorAll('[data-reviews-page-button]'));
    var list = root.querySelector('[data-reviews-list]');
    var empty = root.querySelector('[data-reviews-empty]');
    var pager = root.querySelector('[data-reviews-pager]');

    var storeList = root.querySelector('[data-reviews-store-list]');
    var storePager = root.querySelector('[data-reviews-store-pager]');

    var currentPage = 1;
    var storeCurrentPage = 1;
    var storeRendered = false;

    // Dynamic dates for product reviews
    reviews.forEach(function(el) {
      var off = Number(el.dataset.ageOffset);
      if (off) {
        var dateEl = el.querySelector('.rvw__date');
        if (dateEl) dateEl.textContent = relAge(off);
      }
    });

    // Render store reviews from JSON
    function renderStore() {
      if (storeRendered || !storeList) return;
      var script = root.querySelector('[data-store-reviews]');
      if (!script) return;
      var data;
      try { data = JSON.parse(script.textContent); } catch(e) { return; }
      var html = '';
      for (var idx = 0; idx < data.length; idx++) {
        var rv = data[idx];
        var pg = Math.floor(idx / storePerPage) + 1;
        var vis = pg === 1 ? ' is-visible' : '';
        html += '<article class="rvw__review' + vis + '" data-reviews-store-page="' + pg + '">'
          + '<div class="rvw__who"><div class="rvw__avatar">' + esc(rv.i) + '<b>\u2713</b></div>'
          + '<div><strong>' + esc(rv.a) + '</strong><small>Ellenőrzött vásárlás</small></div></div>'
          + '<div class="rvw__date">' + relAge(rv.o) + '</div>'
          + '<div class="rvw__rating">' + stars(rv.r) + '</div>'
          + '<p>' + esc(rv.b) + '</p>'
          + '</article>';
      }
      storeList.innerHTML = html;

      // Build pager
      var pagerHtml = '';
      for (var p = 1; p <= storePageCount; p++) {
        pagerHtml += '<button type="button"' + (p === 1 ? ' class="is-selected"' : '') + ' data-reviews-store-page-button="' + p + '">' + p + '</button>';
      }
      pagerHtml += '<button type="button" data-reviews-store-page-button="next" aria-label="Következő">›</button>';
      storePager.innerHTML = pagerHtml;

      // Bind pager events
      [].slice.call(storePager.querySelectorAll('[data-reviews-store-page-button]')).forEach(function(btn) {
        btn.addEventListener('click', function() {
          var val = btn.dataset.reviewsStorePageButton;
          showStorePage(val === 'next' ? storeCurrentPage + 1 : Number(val));
          storeList.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      storeRendered = true;
    }

    var showPage = function(page) {
      currentPage = Math.max(1, Math.min(Number(page), pageSize));
      reviews.forEach(function(r) {
        r.classList.toggle('is-visible', r.dataset.reviewsPage === String(currentPage));
      });
      buttons.forEach(function(b) {
        var val = b.dataset.reviewsPageButton;
        b.classList.toggle('is-selected', val === String(currentPage));
        if (val === 'next') b.disabled = currentPage === pageSize;
      });
    };

    var showStorePage = function(page) {
      if (!storePageCount) return;
      storeCurrentPage = Math.max(1, Math.min(Number(page), storePageCount));
      var arts = [].slice.call(storeList.querySelectorAll('[data-reviews-store-page]'));
      arts.forEach(function(r) {
        r.classList.toggle('is-visible', r.dataset.reviewsStorePage === String(storeCurrentPage));
      });
      var btns = [].slice.call(storePager.querySelectorAll('[data-reviews-store-page-button]'));
      btns.forEach(function(b) {
        var val = b.dataset.reviewsStorePageButton;
        b.classList.toggle('is-selected', val === String(storeCurrentPage));
        if (val === 'next') b.disabled = storeCurrentPage === storePageCount;
      });
    };

    buttons.forEach(function(b) {
      b.addEventListener('click', function() {
        var val = b.dataset.reviewsPageButton;
        showPage(val === 'next' ? currentPage + 1 : val);
        if (list) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    var tabs = [].slice.call(root.querySelectorAll('[data-reviews-tab]'));
    tabs.forEach(function(button) {
      button.addEventListener('click', function() {
        var isStore = button.dataset.reviewsTab === 'store';
        tabs.forEach(function(tab) { tab.classList.toggle('is-selected', tab === button); });

        if (isStore) {
          if (list) list.hidden = true;
          if (pager) pager.style.display = 'none';
          if (storeList && storeTotal > 0) {
            renderStore();
            storeList.hidden = false;
            if (storePager) storePager.style.display = 'flex';
            if (empty) empty.style.display = 'none';
            showStorePage(1);
          } else {
            if (empty) empty.style.display = 'block';
          }
        } else {
          if (list) list.hidden = false;
          if (pager) pager.style.display = 'flex';
          if (storeList) storeList.hidden = true;
          if (storePager) storePager.style.display = 'none';
          if (empty) empty.style.display = 'none';
          showPage(currentPage);
        }
      });
    });

    showPage(1);
  };

  document.querySelectorAll('[data-reviews-root]').forEach(init);
})();
